(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["imgWithTextOverlay-WebSystemsSolutions"] && !Shopify.designMode) return;
  try {
    
    var blank = $('#banner_webss').attr( "data-href" );
    if (blank) {
      $('#banner_webss').click(function () {
        window.open(blank, '_blank');
      });
    }

  } catch(e) { console.error(e); }
})();
})();
